import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl flex flex-row items-center space-x-2" }
const _hoisted_2 = { class: "text-sm font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_n_space, { vertical: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_n_space, {
          align: "center",
          class: "flex flex-row items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('TimeZone')), 1)
            ]),
            _createVNode(_component_n_select, {
              class: "sm:w-fit md:w-72",
              value: _ctx.selectedTimezone,
              "onUpdate:value": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTimezone) = $event)),
                _ctx.changeTimezone
              ],
              options: _ctx.timezoneOptions,
              placeholder: _ctx.t('SearchTimeKeyWord'),
              filterable: "",
              clearable: "",
              filter: _ctx.customFilter
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_n_empty, { description: "沒有符合的時區" })
              ]),
              action: _withCtx(() => [
                _createVNode(_component_n_button, {
                  size: "small",
                  onClick: _ctx.useLocalTimezone,
                  block: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('UseLocalTimeZone')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["value", "options", "onUpdate:value", "placeholder", "filter"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}